var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClipboard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-16px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08317 2.0835V2.66622C6.08317 2.66602 6.08317 2.66643 6.08317 2.66622C6.08317 2.66643 6.08317 2.66723 6.08317 2.66743V3.25016H9.9165V2.0835H6.08317ZM11.4141 1.91683C11.371 1.17321 10.7543 0.583496 9.99984 0.583496H5.99984C5.24541 0.583496 4.62872 1.17321 4.58558 1.91683H3.99984C3.4473 1.91683 2.9174 2.13632 2.5267 2.52702C2.136 2.91772 1.9165 3.44763 1.9165 4.00016V13.3335C1.9165 13.886 2.136 14.4159 2.5267 14.8066C2.9174 15.1973 3.4473 15.4168 3.99984 15.4168H11.9998C12.5524 15.4168 13.0823 15.1973 13.473 14.8066C13.8637 14.4159 14.0832 13.886 14.0832 13.3335V4.00016C14.0832 3.44763 13.8637 2.91772 13.473 2.52702C13.0823 2.13632 12.5524 1.91683 11.9998 1.91683H11.4141ZM11.4141 3.41683C11.371 4.16044 10.7543 4.75016 9.99984 4.75016H5.99984C5.24541 4.75016 4.62872 4.16044 4.58558 3.41683H3.99984C3.84513 3.41683 3.69675 3.47829 3.58736 3.58768C3.47796 3.69708 3.4165 3.84545 3.4165 4.00016V13.3335C3.4165 13.4882 3.47796 13.6366 3.58736 13.746C3.69676 13.8554 3.84513 13.9168 3.99984 13.9168H11.9998C12.1545 13.9168 12.3029 13.8554 12.4123 13.746C12.5217 13.6366 12.5832 13.4882 12.5832 13.3335V4.00016C12.5832 3.84545 12.5217 3.69708 12.4123 3.58768C12.3029 3.47829 12.1545 3.41683 11.9998 3.41683H11.4141Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClipboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clipboard.880e3bc9.svg";
export { ForwardRef as ReactComponent };